$(function () {

    'use strict';

    RivalIQ.apps.Shell.execute('show:app', {
        app: RivalIQ.apps.Dashboard
    });
});
